<script setup lang="ts">
import "swiper/css";
import "swiper/css/pagination";

import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";

import slide1 from "./slide1.vue";
import slide2 from "./slide2.vue";

const modules = [Pagination];
</script>

<template>
  <div class="wrapper-for-swiper-tutorial">
    <swiper
      :modules="modules"
      :navigation="true"
      :pagination="true"
      :slides-per-view="1"
      :space-between="0"
      :loop="false"
      :allow-touch-move="true"
      class="swiper-tutorial"
    >
      <swiper-slide>
        <div class="slide-container">
          <slide1 />
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="slide-container">
          <slide2 />
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="slide-container video-container">
          <video playsinline muted loop autoplay class="video-element-tutorial">
            <source src="@/assets/video/SearchTutorial.mp4" type="video/webm" />
            <p>Ваш браузер не поддерживает видео.</p>
          </video>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<style scoped>
.wrapper-for-swiper-tutorial {
  width: 100%;
  height: 100%;
}

.swiper-tutorial {
  width: 100%;
  height: 100%;
}

.slide-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slide-img {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.video-container {
  padding: 10px;
  border-radius: 40px;
  background-image: url("../../../assets/img/BG.webp");
  background-size: 100% 100%;
}

.video-element-tutorial {
  max-height: 90%;
  border-radius: 40px;
  overflow: hidden;
}

:deep(.swiper-wrapper) {
  padding-bottom: 0;
  height: 100%;
}

:deep(.swiper-slide) {
  height: 100%;
}

:deep(.swiper-pagination) {
  bottom: 30px;
  z-index: 2;
}

:deep(.swiper-pagination-bullet) {
  width: 50px;
  background: var(--white-40);
}

:deep(.swiper-pagination-bullet-active) {
  background: white;
}

@media (max-width: 1024px) {
  .swiper-tutorial {
    height: 80vh;
  }

  :deep(.swiper-slide) {
    height: auto;
  }
}

/* Стили для навигации */
:deep(.swiper-button-next),
:deep(.swiper-button-prev) {
  color: white;
  background: transparent;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

:deep(.swiper-button-next:after),
:deep(.swiper-button-prev:after) {
  font-size: 20px;
}
</style>
